export enum MaskPlaceholder {
  DATE = 'MM/DD/YYYY',
  PHONE = 'X',
}
